import { IAPIRoutes } from "../../../../config";

export type IClinicRepository = ReturnType<typeof ClinicRepositoryFactory>;

export const ClinicRepositoryFactory = ({
  APIProvider,
  AuthService,
  APIRoutes,
}: {
  APIProvider: IAPIProvider;
  AuthService: IAuthService;
  APIRoutes: IAPIRoutes;
}) => {
  const { GET, POST, DELETE } = APIProvider;
  const { getAuthenticationToken } = AuthService;

  const getClinicID: IGetMyClinicAPI = async () =>
    GET(
      APIRoutes.apiMyClinic,
      {},
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      }
    );

  const getClinicFloor: IGetClinicFloorAPI = async (obj) =>
    GET(
      APIRoutes.apiGetClinicFloor.replace("{clinic_id}", String(obj.clinic_id)),
      obj,
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      }
    );

  const setClinicFloor: ISetClinicFloorAPI = async ({ clinic_id, ...obj }) =>
    POST(
      APIRoutes.apiSetClinicFloor.replace("{clinic_id}", clinic_id?.toString()),
      obj,
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      }
    );

  const logError: ILogErrorAPI = async (obj) =>
    POST(APIRoutes.apiMixPanelErrorStore, obj, {
      Authorization: `Bearer ${await getAuthenticationToken()}`,
    });

  const fetchAssignedDeviceAPI: IFetchAssignedDeviceORAssingDeviceToAPatientAPI =
    async (obj) =>
      GET(
        APIRoutes.apiFetchAssignedDeviceORAssingDeviceToAPatient
          .replace("{clinic_id}", obj.clinic_id?.toString())
          .replace("{patient_id}", obj.patient_id?.toString()),
        obj,
        {
          Authorization: `Bearer ${await getAuthenticationToken()}`,
        }
      );

  const assingDeviceToAPatient: IAssingDeviceToAPatientAPI = async (obj) =>
    POST(
      APIRoutes.apiFetchAssignedDeviceORAssingDeviceToAPatient
        .replace("{clinic_id}", obj.clinic_id?.toString())
        .replace("{patient_id}", obj.patient_id?.toString()),
      obj,
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      }
    );

  const deleteAccount: IDeleteAccountAPI = async (obj) =>
    DELETE(
      APIRoutes.apiDeleteAccount
        .replace("{clinic_id}", obj.clinic_id?.toString())
        .replace("{patient_id}", obj.patient_id?.toString()),
      obj,
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      }
    );

  return {
    getClinicFloor,
    getClinicID,
    setClinicFloor,
    logError,
    fetchAssignedDeviceAPI,
    assingDeviceToAPatient,
    deleteAccount,
  };
};
